// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ucqt","right":"styles_right__31-M8"};